<script setup lang="ts">
import { ref } from "vue";
import { ApiError } from "../api";
import { useSessionStore } from "../stores/session";

const session = useSessionStore();
const token = ref("");
const error = ref("");
const loading = ref(false);
async function submit(): Promise<void> {
  error.value = "";
  loading.value = true;
  try {
    await session.login(token.value);
    token.value = "";
  } catch (caught) {
    error.value = caught instanceof ApiError && caught.status === 401 ? "Неверный административный токен" : "Не удалось открыть сессию";
  } finally {
    loading.value = false;
  }
}
</script>
<template>
  <main class="login-page">
    <section class="login-panel">
      <div class="brand login-brand"><div class="brand-mark"><i class="bi bi-stars" /></div><div><strong>AI Market</strong><span>Control Center</span></div></div>
      <div class="login-copy"><p class="eyebrow">Защищённая зона</p><h1>Управляйте магазином<br />без слепых зон.</h1><p>Синхронизации, поисковый индекс и расходы AI — в одном операционном центре.</p></div>
      <div class="login-signal"><span class="pulse" /><span>Service contour</span><strong>готов к подключению</strong></div>
    </section>
    <section class="login-form-wrap">
      <form class="login-card" @submit.prevent="submit">
        <div class="login-icon"><i class="bi bi-shield-lock" /></div>
        <p class="eyebrow">Вход администратора</p>
        <h2>Открыть панель</h2>
        <p class="text-secondary">Для локального контура используйте значение <code>ADMIN_API_TOKEN</code>. Токен обменивается на HttpOnly-сессию и не сохраняется браузером.</p>
        <label class="form-label" for="token">Административный токен</label>
        <input id="token" v-model="token" class="form-control form-control-lg" type="password" autocomplete="current-password" required />
        <div v-if="error" class="alert alert-danger mt-3 mb-0" role="alert">{{ error }}</div>
        <button class="btn btn-primary btn-lg w-100 mt-4" :disabled="loading || !token">
          <span v-if="loading" class="spinner-border spinner-border-sm me-2" />Войти
        </button>
      </form>
    </section>
  </main>
</template>
